import {Container, Row, Col, Card} from "reactstrap";
import Header from "components/Headers/Header";
const CoachDashboard = () => {
    return (
        <>
        {/* Create a card with coming soon message */}
        <Header />
        <Container className="mt--7" fluid>
            <Row>
                <Col>
                    <Card className="p-4">
                        <h1>Coach Dashboard</h1>
                        <p>Welcome to the Coach Dashboard!</p>
                        Coming soon...
                    </Card>
                </Col>
            </Row>
        </Container>
        </>
    )

}
export default CoachDashboard;